import { EventEmitter, Injectable } from '@angular/core';
import { Subject, Subscription } from 'rxjs';

@Injectable()
export class InputStateService {
	
	stateChanged = new Subject<InputState>();
	currentState = InputState.Blur;
	private activated = new EventEmitter();

	
	private inputStateChanged(state: InputState): void {
		if (this.currentState === state) return;
		this.currentState = state;
		this.stateChanged.next(state);
	}

	activate() {
		this.activated.emit();
	}
	onActivated(callback: Function) : Subscription {
		return this.activated.subscribe(callback);
	}

	focus() {
		this.inputStateChanged(InputState.Focus);
	}

	blur() {
		this.inputStateChanged(InputState.Blur);
	}

	setHover(hover: boolean) {
		if (this.currentState === InputState.Focus) return;
		this.inputStateChanged(hover ? InputState.Hover : InputState.Blur);
	}
}

export enum InputState {
	Blur, Hover, Focus
}